import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
import { Spinner } from "@blueprintjs/core";

class AppLoading extends PureComponent {
  static propTypes = {
    application: PropTypes.object.isRequired,
    database: PropTypes.object.isRequired,
    onReload: PropTypes.func
  };

  static defaultProps: {
    onReload: () => {}
  };

  render() {
    if (this.props.application.isLoading || this.props.database.isLoading) {
      return (
        <div className="loading-container">
          <Spinner size={60} intent="danger" />
          <span>Loading ...</span>
        </div>
      );
    }
    return null;
  }
}

export default withNamespaces(["common"], { wait: true })(AppLoading);
